import React from "react";
import { Box, Typography } from "@mui/material";

function Dashboard() {
  return (
    <Box sx={{ px: 3, pt: 5 }}>
      <Typography variant="h2" sx={{ fontWeight: "bold", color: "#000" }}>
        Dashboard
      </Typography>
      <Typography sx={{ color: "rgb(107, 114, 128)", mt: 1, fontSize: "15px" }}>
        Welcome back to Puri Polymers Admin Panel
      </Typography>
    </Box>
  );
}

export default Dashboard;
